// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter";

export interface PSTreemapNode {
  name: string;
  children: PSTreemapNode[];
  unusedBytes?: number;
  resourceBytes: number;
}

interface TreemapNodeProps {
  node: PSTreemapNode;
}
export const TreemapNode = ({node}: TreemapNodeProps) => (
  <li>
    <div>
      {node.name}
      Resource: {Formatter.humanBytes(node.resourceBytes)}
      {node.unusedBytes && <span>Unused bytes: {Formatter.humanBytes(node.unusedBytes)}</span>}
    </div>
    <ul>
      {node.children.map((n) => (
        <TreemapNode node={n} />
      ))}
    </ul>
  </li>
);
